import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApi from "../utils/useApi";

export default function useEventsLastChange({ enabled = true }) {
  const { getEventsLastChange } = useApi();
  const { user } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: [
      "eventsLastChange",
      user?.user_id ?? null,
      user?.active_branch_id ?? null,
    ],
    queryFn: getEventsLastChange,
    enabled,
  });

  return { data: data?.data, isLoading, error };
}
